import * as yup from 'yup';

export const PropiedadColumnList = (isAdmin) => {
   return [
      {
         id: 'propiedad_id',
         dbname: 'id',
         label: 'id',
         visible: false,
         form: false,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'propiedad_nomenclatura',
         dbname: 'nomenclatura',
         label: 'nomenclatura',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
         maxLen: 45
      },
      {
         id: 'propiedad_conjunto_id',
         dbname: 'conjunto_id',
         label: 'conjunto_id',
         visible: !!isAdmin,
         form: !!isAdmin,
         filter: !!isAdmin,
         foreign: {
            table: 'conjunto',
            label: 'conjunto',
            dbname: 'conjuntodesc',
            type: 'large'
         }
      },
      {
         id: 'propiedad_tipo_propiedad_id',
         dbname: 'tipo_propiedad_id',
         label: 'tipo_propiedad_id',
         visible: true,
         form: true,
         filter: true,
         foreign: {
            table: 'tipo_propiedad',
            label: 'tipo_propiedad',
            dbname: 'tipo_propiedaddesc',
            type: 'small'
         }
      },
      {
         id: 'propiedad_area_comun',
         dbname: 'area_comun',
         label: 'area_comun',
         visible: true,
         form: true,
         filter: true,
         align: 'right',
         type: 'decimal',
         minValue: 0,
         maxValue: 999999
      },
      {
         id: 'propiedad_area_privada',
         dbname: 'area_privada',
         label: 'area_privada',
         visible: true,
         form: true,
         filter: true,
         align: 'right',
         type: 'decimal',
         minValue: 0,
         maxValue: 999999
      },
      {
         id: 'propiedad_coeficiente',
         dbname: 'coeficiente',
         label: 'coeficiente',
         visible: true,
         form: true,
         filter: true,
         align: 'right',
         type: 'decimal',
         minValue: 0,
         maxValue: 1,
         maxDecimals: 8
      },
      {
         id: 'propiedad_numero_matricula',
         dbname: 'numero_matricula',
         label: 'numero_matricula',
         visible: true,
         form: true,
         filter: true,
         type: 'string',
         maxLen: 45
      },
      {
         id: 'propiedad_bloque',
         dbname: 'bloque',
         label: 'bloque',
         visible: true,
         form: true,
         filter: true,
         type: 'string',

      },
      {
         id: 'propiedad_piso',
         dbname: 'piso',
         label: 'piso',
         visible: true,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'propiedad_numero',
         dbname: 'numero',
         label: 'numero',
         visible: true,
         form: true,
         filter: true,
         align: 'right',
         type: 'number',
      },
      {
         id: 'propiedad_saldo_inicial',
         dbname: 'saldo_inicial',
         label: 'saldo_inicial',
         visible: true,
         form: true,
         filter: true,
         align: 'right',
         type: 'decimal',
      },
      {
         id: 'propiedad_fecha_creacion',
         dbname: 'fecha_creacion',
         label: 'fecha_creacion',
         visible: true,
         form: false,
         filter: false,
         type: 'datetime',
      },
      {
         id: 'propiedad_fecha_actualizacion',
         dbname: 'fecha_actualizacion',
         label: 'fecha_actualizacion',
         visible: false,
         form: false,
         filter: false,
         type: 'datetime',
      },

   ];
};

export const PropiedadValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nomenclatura: yup.string().nullable(),
      conjunto_id: yup.number().nullable(),
      tipo_propiedad_id: yup.number().nullable(),
      area_comun: yup.number().nullable(),
      area_privada: yup.number().nullable(),
      coeficiente: yup.number().nullable(),
      numero_matricula: yup.string().nullable(),
      bloque: yup.string().nullable(),
      piso: yup.number().nullable(),
      numero: yup.number().nullable(),
      saldo_inicial: yup.number().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),

   });
};

export const PropiedadFilterValidationSchema = (t) => {
   return yup.object().shape({
      id: yup.number().nullable(),
      nomenclatura: yup.string().nullable(),
      conjunto_id: yup.number().nullable(),
      tipo_propiedad_id: yup.number().nullable(),
      area_comun: yup.number().nullable(),
      area_privada: yup.number().nullable(),
      coeficiente: yup.number().nullable(),
      numero_matricula: yup.string().nullable(),
      bloque: yup.string().nullable(),
      piso: yup.number().nullable(),
      numero: yup.number().nullable(),
      saldo_inicial: yup.number().nullable(),
      fecha_creacion: yup.date().nullable(),
      fecha_actualizacion: yup.date().nullable(),

   });
};